/**
 * @generated SignedSource<<e4f115121bdb13f07159d944b855c244>>
 * @relayHash 614a7737d5135ab426d8486057468c6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f81135d20785f8777bf257432d9b9190746954f335d2c977fa9d739237dabed4

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "containerId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "containerType"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentType"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "emojiId"
    }],
    v1 = [{
      "args": [{
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }, {
        "kind": "Variable",
        "name": "containerId",
        "variableName": "containerId"
      }, {
        "kind": "Variable",
        "name": "containerType",
        "variableName": "containerType"
      }, {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }, {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }, {
        "kind": "Variable",
        "name": "emojiId",
        "variableName": "emojiId"
      }],
      "concreteType": "SaveReactionResponse",
      "kind": "LinkedField",
      "name": "deleteReaction",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "name": "ari"
      }, {
        "kind": "ScalarField",
        "name": "containerAri"
      }, {
        "kind": "ScalarField",
        "name": "emojiId"
      }]
    }];
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "mainDeleteReactionMutation",
      "selections": v1 /*: any*/,
      "type": "Mutation"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "mainDeleteReactionMutation",
      "selections": v1 /*: any*/
    },
    "params": {
      "id": "f81135d20785f8777bf257432d9b9190746954f335d2c977fa9d739237dabed4",
      "metadata": {},
      "name": "mainDeleteReactionMutation",
      "operationKind": "mutation",
      "text": null
    }
  };
}();
node.hash = "3e2ccb1a885d63736c8542924670b618";
export default node;